function normalizeVerificationError(error) {
  const message = String(error?.message || '');

  if (message.includes('Failed to fetch') || message.includes('NetworkError')) {
    return '无法连接验证服务，请检查网络后重试';
  }

  if (message.includes('Unauthorized') || message.includes('Authentication')) {
    return 'Token 认证失败，请确认 Token 未过期且权限正确';
  }

  return message || 'Cloudflare Token 校验失败';
}

function isLikelyCloudflareToken(token) {
  const normalized = String(token || '').trim();
  if (!normalized) return false;
  if (normalized.length < 30) return false;
  return /^[A-Za-z0-9._-]+$/.test(normalized);
}

// Security-first local validation.
// Real permission/account verification is completed against the user-owned control API.
export async function verifyCloudflareTokenAndAccount(token) {
  try {
    if (!isLikelyCloudflareToken(token)) {
      throw new Error('Token 格式无效，请检查后重试');
    }

    return {
      ok: true,
      tokenStatus: 'local-format-validated',
      accountId: '',
      accountName: '',
      verifiedAt: new Date().toISOString(),
      raw: {
        accountCount: 0,
        mode: 'local-only',
      },
    };
  } catch (error) {
    return {
      ok: false,
      error: normalizeVerificationError(error),
    };
  }
}
